import React, { useEffect, useState } from 'react';
import Box from '../common/Box';
import AdGenerater from '../ads/AdGenerater.js';
import Tv24Container from './tv24Curation/Tv24Container.js';
import EventBanner from '../live/banner/EventBanner';
import Tv24Banner from '../live/banner/Tv24Banner';

import { toPercentTime } from '../../../common/utils/convertUtil';
import { toPlanUrl } from '../../../common/utils/liveUtil';

export default function LiveChannelTvAndVirtual(props) {
  const [data, setData] = useState(null);
  const [genreData, setGenreData] = useState(null);
  const [genre, setGenre] = useState('');

  const [sort, setSort] = useState('');
  const [curation, setCuration] = useState('curation');

  useEffect(() => {
    if (props.type && props.type.toUpperCase() === '24TV') {
      setData(props.virtual);
      setGenreData(props.virtual);
    } else {
      setData(props.tv);
    }

    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const paramsGenreType = params.get('genre');

    if (paramsGenreType) {
      setGenre(paramsGenreType);
    }
  }, [props]);

  useEffect(() => {
    const handlePopState = () => {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      const paramsGenreType = params.get('genre');

      setGenre(paramsGenreType);
    };
    handlePopState();
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  useEffect(() => {
    if (genre && document.querySelector(`.btnTypeRoundLine-text[data-value="${genre}"]`)) {
      document.querySelector(`.btnTypeRoundLine-text[data-value="${genre}"]`).click();
    }
  }, [genre]);

  const is24HourTv = props.type === '24TV';
  const extractGenreSelection = (data) => {
    try {
      // data = data.sort((a, b) => {
      //   return a.channelid < b.channelid ? -1 : a.channelid > b.channelid ? 1 : 0;
      // });
      let genreSelectionsSet = new Set();
      data.forEach(item => {
        if (item.program.genre_selection && item.program.genre_selection.trim() !== "") {
          genreSelectionsSet.add(item.program.genre_selection);
        }
      });
      return Array.from(genreSelectionsSet);
    } catch (error) {
      return [];
    }
  }
  const customSort = (arr) => {
    const order = ['DR', 'SC', 'ET', 'MS', 'CU', 'SP', 'ST'];
    const maxIndex = order.length;

    arr.sort((a, b) => {
      let indexA = order.indexOf(a);
      let indexB = order.indexOf(b);

      indexA = indexA === -1 ? maxIndex : indexA;
      indexB = indexB === -1 ? maxIndex : indexB;

      return indexA - indexB;
    });

    return arr;
  }
  const mapGenreSelection = (data) => {
    let genreName = '';
    switch (data) {
      case 'DR':
        genreName = '드라마';
        break;
      case 'SC':
        genreName = '시트콤';
        break;
      case 'ET':
        genreName = '예능';
        break;
      case 'MS':
        genreName = '뮤직';
        break;
      case 'CU':
        genreName = '시사교양';
        break;
      case 'SP':
        genreName = '스포츠';
        break;
      case 'ST':
        genreName = '스타';
        break;
      default:
        genreName = '미상';
        break;
    }
    return genreName;
  }

  const array24HourTvSection = !props.virtual ? [] : customSort(extractGenreSelection(props.virtual));

  const genreHandler = (event) => {
    const tagName = event.currentTarget.tagName;
    const parent = event.currentTarget.parentNode;
    const sameTagElements = Array.from(parent.children).filter(child => child.tagName === tagName);
    const selectGenre = event.currentTarget.getAttribute('data-value') !== 'all' ? event.currentTarget.getAttribute('data-value') : '';

    if (selectGenre === 'curation') {
      setCuration(selectGenre)
    } else {
      setCuration('');
    }

    sameTagElements.forEach(item => item.classList.remove('current'));
    event.currentTarget.classList.add('current');

    const data = props.virtual.filter(item => item.program.genre_selection.trim() === selectGenre);
    setSort('');
    setData(selectGenre.length === 0 ? props.virtual : data);
    setGenreData(selectGenre.length === 0 ? props.virtual : data);

    if (selectGenre) {
      window.history.pushState({ genre: selectGenre }, '', `/live?type=24tv&genre=${selectGenre}`);
    } else {
      window.history.pushState({ genre: selectGenre }, '', `/live?type=24tv&genre=all`);
    }
  };
  const sortHandler = (event) => {
    const tagName = event.currentTarget.tagName;
    const parent = event.currentTarget.parentNode;
    const sameTagElements = Array.from(parent.children).filter(child => child.tagName === tagName);
    const selectSort = event.currentTarget.getAttribute('data-value')

    sameTagElements.forEach(item => item.classList.remove('current'));
    event.currentTarget.classList.add('current');

    if (selectSort === 'asc') {
      let sortedData = [...data].sort((a, b) => a.channelname.localeCompare(b.channelname, 'ko'));
      setData(sortedData);
      setSort('asc');
    } else {
      setData([...genreData]);
      setSort('');
    }
  };

  const renderItems = (data, channelType = '') => {
    if (!data) return false;
    return data.map((item, index) => {
      let type = channelType === '24tv' ? '2' : '1';
      let percent = toPercentTime(item.starttime, item.endtime);
      let progress = {
        percent: percent,
        status: `${item.starttime}부터 ${item.endtime} 까지 방송예정, 현재 ${percent} 방송 중`
      }
      let channelName = (item.channelname === undefined || (item.channelid && item.channelid.indexOf('EVENT4') > -1)) ? 'SBS' : item.channelname;
      let ch_info = { title: item.title, desc: channelName }
      let label = [];
      let thumbnailImgUrl = item.thumbimg;
      thumbnailImgUrl = (thumbnailImgUrl === undefined) ? '/images/sbs.png' : thumbnailImgUrl;

      if (parseInt(item.target_age) >= 19) label.push({ type: '19' });
      if (item.channelid === 'S01' && item.channelname === 'SBS 카타르 2022' && props.data.filter(element => element.channelid === 'S01').length > 1) {
        return false;
      }

      return <li key={index} className="live_list_cont">
        <Box view={true} type={type} imageQuality={75} info={ch_info} img={thumbnailImgUrl} link={(item.channelid === 'EVENT4' && item.homeurl.length > 0) ? item.homeurl : `/live/${item.channelid}`} progress={progress} label={label} clickParams="div=live_list" />
      </li>
    })
  }

  return (
    <>
      <div className={`${is24HourTv ? curation ? 'contents_area_curation' : 'contents_area_24tv' : 'contents_area_livetv'}`}>
        <div className='module_titleline_w'>
          <h3 className={`module_titleline_title ${!is24HourTv ? 'current' : ''}`}><a href={'/live'} className='module_titleLink'>실시간 라이브</a></h3>
          <h3 className={`module_titleline_title ${is24HourTv ? 'current' : ''}`}><a href={'/live?type=24tv'} className='module_titleLink'>24시간 TV</a><span className="glist_iconSvg_new"><i className="hide">New</i></span></h3>
          {!is24HourTv && <a href={`${toPlanUrl('tv')}`} className='module_titleline_link'>{is24HourTv ? '편성보기' : '전체 편성표'}</a>}
        </div>
        {is24HourTv && array24HourTvSection.length && (
          <div className="livetv_topMenu">
            <div className="tabList_w">
              <a className="btnTypeRoundLine-text current" data-value="curation" onClick={genreHandler}><span className="btn_text">추천</span></a>
              <a className="btnTypeRoundLine-text" data-value="all" onClick={genreHandler}><span className="btn_text">전체</span></a>
              {
                array24HourTvSection.map((item, index) => {
                  return <a key={index} className="btnTypeRoundLine-text" data-value={item} onClick={genreHandler}><span className="btn_text">{mapGenreSelection(item)}</span></a>
                })
              }
            </div>
            {!curation && (
              <div className="sorting_btn_w">
                <a className={`sorting_btn_cont ${sort !== 'asc' ? 'current' : ''}`} data-value="top" onClick={sortHandler}><span className="sorting_btn_text">최신</span></a>
                <a className={`sorting_btn_cont ${sort === 'asc' ? 'current' : ''}`} data-value="asc" onClick={sortHandler}><span className="sorting_btn_text">가나다</span></a>
              </div>
            )}
          </div>
        )}

        {is24HourTv && curation &&
          props.virtual_curation_banner && <Tv24Banner {...props.virtual_curation_banner} />
        }

        <div className='live_list_w'>
          {!curation && is24HourTv && data.slice(0, 9).length > 0 && (<ul className="live_list_inner">{renderItems(data.slice(0, 9), props.type)}</ul>)}
          {!curation && is24HourTv && data.slice(9, 18).length > 0 && (<><AdGenerater id='24live_web_middle_970_90' w='970' h='90' />
            <ul className="live_list_inner">{renderItems(data.slice(9, 18), props.type)}</ul>
          </>)}
          {!curation && is24HourTv && data.slice(18, data.length).length > 0 && (<><AdGenerater id='24live_web_middle_970_90' w='970' h='90' />
            <ul className="live_list_inner">{renderItems(data.slice(18, data.length), props.type)}</ul>
          </>)}
          {!is24HourTv && (<ul className="live_list_inner">{renderItems(data, props.type)}</ul>)}
        </div>
      </div>
      {is24HourTv && curation && (
        <Tv24Container data={props.virtual_curation} />
      )}
    </>
  );
}
